import { DownloadController } from './download.controller';
import template from './download.html';

export const downloadComponent = {
  name: 'download',
  restrict: 'E',
  template,
  controller: DownloadController,
  controllerAs: 'vm',
  bindings: {
    label: '@',
    download: '&',
    title: '@',
    body: '@'
  }
};
